module.exports = __webpack_public_path__ + "img/Tela docxsustentabilidade.a4868a1d.jpg";